import { signInWithEmailAndPassword, signOut, onAuthStateChanged, type User, type Auth, type Unsubscribe } from 'firebase/auth';

let unwatchAuthState: Unsubscribe = () => { }

export const useFirebaseAuth = () => {
    const auth = useNuxtApp().$auth as Auth;
    const user = useState<User | null>('user', () => null);
    const loading = useState<boolean>('loading', () => false);
    const userToken = useState<string | null>('userToken', () => null);
    // const unsubscribe = useState<(() => void) | null>('unsubscribe', () => null);

    const watchAuthState = () => {
        unwatchAuthState()

        unwatchAuthState = onAuthStateChanged(auth, newUser => {
            if (newUser) {
                user.value = newUser
            } else {
                user.value = null
            }
        })
    }


    const login = async (email: string, password: string) => {
        try {
            loading.value = true;
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            return userCredential.user;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        } finally {
            loading.value = false;
        }
    };

    const logout = async () => {
        try {
            loading.value = true;
            await signOut(auth);
        } catch (error) {
            console.error('Logout error:', error);
            throw error;
        } finally {
            loading.value = false;
        }

    };

    const isLoggedIn = computed(() => user.value !== null);
    watch(user, async () => {
        if (user.value) {
            userToken.value = await user.value.getIdToken();
        }
    });

    return {
        login,
        logout,
        isLoggedIn,
        user,
        loading,
        userToken,
        watchAuthState,
        unwatchAuthState
    };
}; 